import {
  eachDayOfInterval,
  endOfMonth,
  endOfYear,
  isWeekend,
  parseISO,
  startOfMonth,
  startOfYear,
} from 'date-fns';

type Interval = {
  start: Date;
  end: Date;
};

export type DateRange =
  | { type: 'notSet' }
  | { type: 'month'; month: Date }
  | { type: 'year'; year: Date }
  | { type: 'range'; interval: Interval };

export function createDateRange(
  startDate: string,
  endDate: string,
  createWorkForWeekendDays: boolean
): Date[] {
  return eachDayOfInterval({
    start: parseISO(startDate),
    end: parseISO(endDate),
  }).filter((day) => (createWorkForWeekendDays ? true : !isWeekend(day)));
}

export function getInterval(dateRange: DateRange): Interval {
  switch (dateRange.type) {
    case 'month':
      return {
        start: startOfMonth(dateRange.month),
        end: endOfMonth(dateRange.month),
      };
    case 'year':
      return {
        start: startOfYear(dateRange.year),
        end: endOfYear(dateRange.year),
      };
    case 'range':
      return dateRange.interval;
    default:
      throw Error('no interval possible');
  }
}

export function test() {
  //const hans: DateRange;
}
